







































































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import Heading from '@/modules/common/layout/components/shared/Heading.vue'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import WebUserAuthCard from '@/modules/user/components/web/auth/WebUserAuthCard.vue'
import Checkbox from '@/modules/shared/components/shared/kit/Checkbox.vue'
import AuthRoute from '@/modules/user/routes/auth.route'
import Copyright from '@/modules/shared/components/panel/Copyright.vue'
import Logo from '@/modules/shared/components/shared/Logo.vue'
import QForm from 'quasar/src/components/form/QForm.js';
import { UserLoginRequestModel } from '@/modules/user/models/user-request.model'
import WebLayout from '@/modules/common/layout/components/web/WebLayout.vue'
import { AuthService } from '@/modules/user/services/auth.service'


@Component({
  layout: WebLayout,
  metaInfo: {
    title: 'ورود'
  },
  components: { Logo, Copyright, Checkbox, WebUserAuthCard, BaseCard, Heading, BaseInput, BaseButton }
})
export default class LoginPage extends Vue {
  constructor(
    private readonly routes: AuthRoute,
    private readonly services: AuthService
  ) {
    super()
  }

  $refs!: {
    loginForm: QForm
  }

  loginModel: UserLoginRequestModel = {
    username: '',
    password: '',
    remember: true
  }
  disabledLogin = false
  loginLoading = false

  login() {
    this.loginLoading = true
    this.$refs.loginForm.validate().then(success => {
      if (success) {
        this.services.login(this.loginModel).onSuccess((response) => {
          this.disabledLogin = true
          location.href = response.props.redirectUrl
        }).onFinish(() => {
          this.loginLoading = false
        })
      } else this.loginLoading = false
    })
  }

}
